// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_c9-2";
export var aiChatCartContainerExit = "_c9-4";
export var aiChatContainerLarge = "_c9-0";
export var aiChatContainerSmall = "_c9-1";
export var aiChatIcon = "_c9-6";
export var slideInFromRight = "_c9-3";
export var slideOutToRight = "_c9-5";